import { CxEvent } from '@spartacus/core';

export class Ga4GgCartRemoveEntrySuccessEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: {
      item_id?: string;
      item_name?: string;
      price?: number;
      quantity?: number;
      item_list_name?: string;
    }[];
  } | null;
}
